import { HttpEvent, HttpRequest, HttpResponse } from "@angular/common/http";

export abstract class EdtellRouterInterceptor {
  abstract onRequest(request: HttpRequest<unknown>): HttpRequest<unknown>;
  abstract onResponse(response: HttpEvent<unknown>): void | Promise<void>;

  /**
   * Used to determine whether or not interceptor will fire based up the request being sent
   * @param request
   * @returns
   */
  applyInterceptor(request: HttpRequest<unknown>): boolean {
    return true;
  }
}
